const RECIPE_INPUT_PATH = /^\/api\/(?:explore|profile)\/recipe-input\/[0-9a-f-]+\/(?:[0-9]|1[0-4])$/iu;
const CHILD_SESSION_KEY = 'botgo.creation.child-session.v1';

function isRecipeInput(value, origin) {
  if (typeof value !== 'string') return false;
  try {
    const url = new URL(value, origin);
    return url.origin === origin && RECIPE_INPUT_PATH.test(url.pathname);
  } catch {
    return false;
  }
}

export function attachRecreateSession(requestData, { origin, storage } = {}) {
  if (!requestData || !origin || !storage) return requestData;
  const assets = Array.isArray(requestData.inputAssets) ? requestData.inputAssets : [];
  const hasRecipeInput = [requestData.imageUrl, ...assets.map((asset) => (
    typeof asset === 'string' ? asset : asset?.url
  ))].some((value) => isRecipeInput(value, origin));
  if (!hasRecipeInput) return requestData;

  let sessionId;
  try { sessionId = storage.getItem(CHILD_SESSION_KEY); } catch { return requestData; }
  if (!sessionId) return requestData;
  return {
    ...requestData,
    creationSessionId: requestData.creationSessionId || sessionId,
    creationEntryPoint: requestData.creationEntryPoint || 'recreate',
  };
}
